import { MultiSelect } from "primereact/multiselect";
import { getAvailableFundamentalQuestions } from "./analyticsConstants";

// A plain-language summary of what this experiment's data can actually say
// about the categories from the "Fundamental Questions Answered by
// Simulation Experiments" framework (Sacks et al., 1989). Each card points
// to the chart tab below with the underlying data. `visibleKeys` (and
// `setVisibleKeys`) let the user narrow down which of the available cards
// show, via the multi-select -- defaulted upstream in AnalyticsPanel to
// every card this experiment has an answer for.
export default function FundamentalQuestionsSection({
  fundamentalQuestions,
  visibleKeys,
  setVisibleKeys,
}) {
  if (!fundamentalQuestions) {
    return null;
  }

  const availableQuestions =
    getAvailableFundamentalQuestions(fundamentalQuestions);

  return (
    <div style={{ marginBottom: "2rem" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: "1rem",
          marginBottom: "1rem",
        }}
      >
        <h2 style={{ margin: 0 }}>Fundamental Questions</h2>
        <MultiSelect
          value={visibleKeys}
          onChange={(e) => setVisibleKeys(e.value)}
          options={availableQuestions}
          optionValue="key"
          optionLabel="title"
          display="chip"
          placeholder="Select cards to show"
          style={{ minWidth: "280px" }}
        />
      </div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "1rem",
        }}
      >
        {availableQuestions
          .filter(({ key }) => visibleKeys.includes(key))
          .map(({ key, title, tabHint }) => {
            const answer = fundamentalQuestions[key];

            return (
              <div
                key={key}
                style={{
                  flex: "1",
                  minWidth: "280px",
                  border: "1px solid #dee2e6",
                  borderRadius: "4px",
                  padding: "1rem",
                  backgroundColor: answer.answered ? "#f8f9fa" : "#f1f1f1",
                  opacity: answer.answered ? 1 : 0.85,
                }}
              >
                <h4 style={{ marginTop: 0, marginBottom: "0.5rem" }}>
                  {answer.answered ? "✅" : "✖️"} {title}
                </h4>
                <div style={{ marginBottom: "0.5rem" }}>{answer.headline}</div>
                {answer.detail && (
                  <div
                    style={{
                      fontSize: "0.8rem",
                      color: "#666",
                      fontStyle: "italic",
                    }}
                  >
                    {answer.detail}
                  </div>
                )}
                {answer.answered && (
                  <div style={{ fontSize: "0.8rem", marginTop: "0.5rem" }}>
                    See <strong>{tabHint}</strong> below.
                  </div>
                )}
              </div>
            );
          })}
      </div>
    </div>
  );
}
